/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { httpService, offeringIdsService } from "../../../../services";
import { HTTP_METHOD } from "@nf/constants";
import { ITagModel, ITagListModel } from "../models";
import { normalizeGenreTagUrl } from "../helpers/genreTagUrl";

export class TagService {
  get url(): string {
    return `/v1/tag`;
  }

  public get = (assetId: string | number): Promise<ITagModel> =>
    httpService.request<ITagModel>({
      method: HTTP_METHOD.GET,
      url: `${this.url}/asset/${assetId}`,
    });

  public search = (
    pageSize: number = 50,
    pageNumber: number = 1,
    sort?: string,
    scheme?: "other" | "genre" | undefined
  ): Promise<ITagListModel> => {
    const params = {
      pageSize,
      pageNumber,
      scheme,
      sort,
    };
    return httpService.request<ITagListModel>({
      axiosConfig: {
        params,
      },
      method: HTTP_METHOD.GET,
      url: this.url,
    });
  };

  public searchByTagType = async (
    tagType: string,
    pageSize: number = 50,
    pageNumber: number = 1
  ): Promise<ITagListModel> => {
    const params = {
      pageSize,
      pageNumber,
      tagType,
      products: await offeringIdsService.getOfferingIds(),
    };
    return httpService.request<ITagListModel>({
      axiosConfig: {
        params,
      },
      method: HTTP_METHOD.GET,
      url: `${this.url}/asset`,
    });
  };

  public searchByUrl = async (
    url: string,
    extraTagIds?: string[],
    pageSize?: number
  ): Promise<ITagListModel> => {
    let params: { products?: string } = {};

    params = await offeringIdsService.includeProductsIdsParam(params);

    return httpService.request<ITagListModel>({
      axiosConfig: { params },
      method: HTTP_METHOD.GET,
      url: normalizeGenreTagUrl(url, extraTagIds, pageSize),
    });
  };
}
